// This file is auto-generated by @hey-api/openapi-ts

import type { Options as ClientOptions, TDataShape, Client } from './client';
import type { BaseRatesGetAllBaseRatesData, BaseRatesGetAllBaseRatesResponses, BaseRatesGetAllBaseRatesErrors, GetBaseRateData, GetBaseRateResponses, GetBaseRateErrors, BaseRatesCreateChangeRequestData, BaseRatesCreateChangeRequestResponses, BaseRatesCreateChangeRequestErrors, BaseRatesCheckBaseRateUsageData, BaseRatesCheckBaseRateUsageResponses, BaseRatesCheckBaseRateUsageErrors, BaseRatesValidateDeleteData, BaseRatesValidateDeleteResponses, BaseRatesValidateDeleteErrors, BaseRatesCreateDeleteCrData, BaseRatesCreateDeleteCrResponses, BaseRatesCreateDeleteCrErrors, BaseRatesGetDataData, BaseRatesGetDataResponses, BaseRatesGetDataErrors, BaseRatesAddOrUpdateDataData, BaseRatesAddOrUpdateDataResponses, BaseRatesAddOrUpdateDataErrors, BaseRatesDeleteDataData, BaseRatesDeleteDataResponses, BaseRatesGetResultData, BaseRatesGetResultResponses, BaseRatesGetResultErrors, BdmGetAllData, BdmGetAllResponses, BdmGetAllErrors, BdmGetByIdData, BdmGetByIdResponses, BdmGetByIdErrors, ChangeRequestCreateDraftData, ChangeRequestCreateDraftResponses, ChangeRequestCreateDraftErrors, ChangeRequestGetData, ChangeRequestGetResponses, ChangeRequestGetErrors, ChangeRequestGetLatestChangeRequestsData, ChangeRequestGetLatestChangeRequestsResponses, ChangeRequestGetLatestChangeRequestsErrors, ChangeRequestApproveData, ChangeRequestApproveResponses, ChangeRequestApproveErrors, ChangeRequestRejectData, ChangeRequestRejectResponses, ChangeRequestRejectErrors, ChangeRequestResubmissionRequiredData, ChangeRequestResubmissionRequiredResponses, ChangeRequestResubmissionRequiredErrors, ChangeRequestApplyChangeRequestData, ChangeRequestApplyChangeRequestResponses, ChangeRequestApplyChangeRequestErrors, ChangeRequestFlipBetweenCloneAndReplaceData, ChangeRequestFlipBetweenCloneAndReplaceResponses, ChangeRequestFlipBetweenCloneAndReplaceErrors, ChangeRequestDeleteData, ChangeRequestDeleteResponses, ChangeRequestDeleteErrors, ConfigurationsGetConfigurationData, ConfigurationsGetConfigurationResponses, GetAllBrandsData, GetAllBrandsResponses, GetAllAdditionalFieldsData, GetAllAdditionalFieldsResponses, ErcProfilesGetAllErcProfilesData, ErcProfilesGetAllErcProfilesResponses, ErcProfilesGetAllErcProfilesErrors, ErcProfilesCheckUsageData, ErcProfilesCheckUsageResponses, ErcProfilesCheckUsageErrors, ErcProfilesCreateChangeRequestData, ErcProfilesCreateChangeRequestResponses, ErcProfilesCreateChangeRequestErrors, ErcProfilesValidateDeleteData, ErcProfilesValidateDeleteResponses, ErcProfilesValidateDeleteErrors, ErcProfilesCreateDeleteCrData, ErcProfilesCreateDeleteCrResponses, ErcProfilesCreateDeleteCrErrors, ErcProfilesGetDataData, ErcProfilesGetDataResponses, ErcProfilesGetDataErrors, ErcProfilesAddOrUpdateDataData, ErcProfilesAddOrUpdateDataResponses, ErcProfilesAddOrUpdateDataErrors, ErcProfilesDeleteDataData, ErcProfilesDeleteDataResponses, ErcProfilesDeleteDataErrors, ErcProfilesGetResultData, ErcProfilesGetResultResponses, ErcProfilesGetResultErrors, ExchangeRatesGetAllExchangeRatesData, ExchangeRatesGetAllExchangeRatesResponses, ExchangeRatesGetAllExchangeRatesErrors, ExchangeRatesCreateChangeRequestData, ExchangeRatesCreateChangeRequestResponses, ExchangeRatesCreateChangeRequestErrors, ExchangeRatesValidateDeleteData, ExchangeRatesValidateDeleteResponses, ExchangeRatesValidateDeleteErrors, ExchangeRatesCreateDeleteCrData, ExchangeRatesCreateDeleteCrResponses, ExchangeRatesCreateDeleteCrErrors, ExchangeRatesGetDataData, ExchangeRatesGetDataResponses, ExchangeRatesGetDataErrors, ExchangeRatesAddOrUpdateDataData, ExchangeRatesAddOrUpdateDataResponses, ExchangeRatesAddOrUpdateDataErrors, ExchangeRatesDeleteDataData, ExchangeRatesDeleteDataResponses, ExchangeRatesDeleteDataErrors, ExchangeRatesGetResultData, ExchangeRatesGetResultResponses, ExchangeRatesGetResultErrors, GetAllExportTemplatesData, GetAllExportTemplatesResponses, CreateExportTemplateData, CreateExportTemplateResponses, CreateExportTemplateErrors, DeleteExportTemplateData, DeleteExportTemplateResponses, DeleteExportTemplateErrors, UpdateExportTemplateData, UpdateExportTemplateResponses, UpdateExportTemplateErrors, FeeDefinitionsGetAllFeeDefinitionsData, FeeDefinitionsGetAllFeeDefinitionsResponses, FeeDefinitionsGetAllFeeDefinitionsErrors, FeeDefinitionsCheckUsageData, FeeDefinitionsCheckUsageResponses, FeeDefinitionsCheckUsageErrors, FeeDefinitionsCreateChangeRequestData, FeeDefinitionsCreateChangeRequestResponses, FeeDefinitionsCreateChangeRequestErrors, FeeDefinitionsValidateDeleteData, FeeDefinitionsValidateDeleteResponses, FeeDefinitionsValidateDeleteErrors, FeeDefinitionsCreateDeleteCrData, FeeDefinitionsCreateDeleteCrResponses, FeeDefinitionsCreateDeleteCrErrors, FeeDefinitionsGetDataData, FeeDefinitionsGetDataResponses, FeeDefinitionsGetDataErrors, FeeDefinitionsAddOrUpdateDataData, FeeDefinitionsAddOrUpdateDataResponses, FeeDefinitionsAddOrUpdateDataErrors, FeeDefinitionsDeleteDataData, FeeDefinitionsDeleteDataResponses, FeeDefinitionsDeleteDataErrors, FeeDefinitionsGetResultData, FeeDefinitionsGetResultResponses, FeeDefinitionsGetResultErrors, FeeProfilesGetAllFeeProfilesData, FeeProfilesGetAllFeeProfilesResponses, FeeProfilesGetAllFeeProfilesErrors, FeeProfilesCheckUsageData, FeeProfilesCheckUsageResponses, FeeProfilesCheckUsageErrors, FeeProfilesCreateChangeRequestData, FeeProfilesCreateChangeRequestResponses, FeeProfilesCreateChangeRequestErrors, FeeProfilesValidateDeleteData, FeeProfilesValidateDeleteResponses, FeeProfilesValidateDeleteErrors, FeeProfilesCreateDeleteCrData, FeeProfilesCreateDeleteCrResponses, FeeProfilesCreateDeleteCrErrors, FeeProfilesGetDataData, FeeProfilesGetDataResponses, FeeProfilesGetDataErrors, FeeProfilesAddOrUpdateDataData, FeeProfilesAddOrUpdateDataResponses, FeeProfilesAddOrUpdateDataErrors, FeeProfilesDeleteDataData, FeeProfilesDeleteDataResponses, FeeProfilesDeleteDataErrors, FeeProfilesGetResultData, FeeProfilesGetResultResponses, FeeProfilesGetResultErrors, FirmProcFeeAssignmentsGetAllFirmAssignmentsData, FirmProcFeeAssignmentsGetAllFirmAssignmentsResponses, FirmProcFeeAssignmentsGetAllFirmAssignmentsErrors, FirmProcFeeAssignmentsCreateChangeRequestData, FirmProcFeeAssignmentsCreateChangeRequestResponses, FirmProcFeeAssignmentsCreateChangeRequestErrors, FirmProcFeeAssignmentsValidateDeleteData, FirmProcFeeAssignmentsValidateDeleteResponses, FirmProcFeeAssignmentsValidateDeleteErrors, FirmProcFeeAssignmentsCreateDeleteCrData, FirmProcFeeAssignmentsCreateDeleteCrResponses, FirmProcFeeAssignmentsCreateDeleteCrErrors, FirmProcFeeAssignmentsCreateFirmReorderChangeRequestData, FirmProcFeeAssignmentsCreateFirmReorderChangeRequestResponses, FirmProcFeeAssignmentsCreateFirmReorderChangeRequestErrors, FirmProcFeeAssignmentsGetDataData, FirmProcFeeAssignmentsGetDataResponses, FirmProcFeeAssignmentsGetDataErrors, FirmProcFeeAssignmentsAddOrUpdateDataData, FirmProcFeeAssignmentsAddOrUpdateDataResponses, FirmProcFeeAssignmentsAddOrUpdateDataErrors, FirmProcFeeAssignmentsDeleteDataData, FirmProcFeeAssignmentsDeleteDataResponses, FirmProcFeeAssignmentsDeleteDataErrors, FirmProcFeeAssignmentsGetResultData, FirmProcFeeAssignmentsGetResultResponses, FirmProcFeeAssignmentsGetResultErrors, UpdateImportMatchingData, UpdateImportMatchingResponses, ImportMatchingGetImportMatchingOfTypeData, ImportMatchingGetImportMatchingOfTypeResponses, ImportSchemasGetImportSchemasData, ImportSchemasGetImportSchemasResponses, ImportSchemasGetImportSchemasErrors, ImportSchemasGetAnImportSchemaData, ImportSchemasGetAnImportSchemaResponses, ImportSchemasGetAnImportSchemaErrors, ImportsCreateImportData, ImportsCreateImportResponses, ImportsCreateImportErrors, ImportsDeleteImportData, ImportsDeleteImportResponses, ImportsDeleteImportErrors, ImportsGetImportData, ImportsGetImportResponses, ImportsGetImportErrors, ImportsRecreateImportData, ImportsRecreateImportResponses, ImportsRecreateImportErrors, ImportsGetLatestImportsData, ImportsGetLatestImportsResponses, ImportsGetLatestImportsErrors, ImportsGetImportDataData, ImportsGetImportDataResponses, ImportsGetImportDataErrors, ImportsAddImportRowsData, ImportsAddImportRowsResponses, ImportsAddImportRowsErrors, ImportsUpdateImportCellData, ImportsUpdateImportCellResponses, ImportsUpdateImportCellErrors, ImportsDeleteImportRowsData, ImportsDeleteImportRowsResponses, ImportsDeleteImportRowsErrors, ImportsValidateImportData, ImportsValidateImportResponses, ImportsValidateImportErrors, ImportsSubmitForReviewData, ImportsSubmitForReviewResponses, ImportsSubmitForReviewErrors, InterestRatesCreateChangeRequestData, InterestRatesCreateChangeRequestResponses, InterestRatesCreateChangeRequestErrors, InterestRatesValidateIrDeleteData, InterestRatesValidateIrDeleteResponses, InterestRatesValidateIrDeleteErrors, InterestRatesCreateIrDeleteCrData, InterestRatesCreateIrDeleteCrResponses, InterestRatesCreateIrDeleteCrErrors, InterestRatesGetDataData, InterestRatesGetDataResponses, InterestRatesGetDataErrors, InterestRatesAddOrUpdateDataData, InterestRatesAddOrUpdateDataResponses, InterestRatesAddOrUpdateDataErrors, InterestRatesDeleteDataData, InterestRatesDeleteDataResponses, InterestRatesDeleteDataErrors, InterestRatesGetResultData, InterestRatesGetResultResponses, InterestRatesGetResultErrors, IntermediaryGetAllData, IntermediaryGetAllResponses, IntermediaryGetAllErrors, IntermediaryCreateChangeRequestData, IntermediaryCreateChangeRequestResponses, IntermediaryCreateChangeRequestErrors, IntermediaryGetByIdData, IntermediaryGetByIdResponses, IntermediaryGetByIdErrors, IntermediarySendInvitationEmailData, IntermediarySendInvitationEmailResponses, IntermediarySendInvitationEmailErrors, IntermediaryGetIntermediaryFcaDataData, IntermediaryGetIntermediaryFcaDataResponses, IntermediaryGetIntermediaryFcaDataErrors, IntermediaryValidateDeleteData, IntermediaryValidateDeleteResponses, IntermediaryValidateDeleteErrors, IntermediaryCreateDeleteCrData, IntermediaryCreateDeleteCrResponses, IntermediaryCreateDeleteCrErrors, IntermediaryGetDataData, IntermediaryGetDataResponses, IntermediaryGetDataErrors, IntermediaryAddOrUpdateDataData, IntermediaryAddOrUpdateDataResponses, IntermediaryAddOrUpdateDataErrors, IntermediaryDeleteDataData, IntermediaryDeleteDataResponses, IntermediaryDeleteDataErrors, IntermediaryGetResultData, IntermediaryGetResultResponses, IntermediaryGetResultErrors, LenderFirmsGetAllLenderFirmsData, LenderFirmsGetAllLenderFirmsResponses, LenderFirmsGetAllLenderFirmsErrors, LenderFirmsCreateChangeRequestData, LenderFirmsCreateChangeRequestResponses, LenderFirmsCreateChangeRequestErrors, LenderFirmsGetLenderFirmData, LenderFirmsGetLenderFirmResponses, LenderFirmsGetLenderFirmErrors, LenderFirmsGetFirmFcaDataData, LenderFirmsGetFirmFcaDataResponses, LenderFirmsGetFirmFcaDataErrors, LenderFirmsGetTradingAddressesData, LenderFirmsGetTradingAddressesResponses, LenderFirmsGetTradingAddressesErrors, LenderFirmsValidateDeleteData, LenderFirmsValidateDeleteResponses, LenderFirmsValidateDeleteErrors, LenderFirmsCreateDeleteCrData, LenderFirmsCreateDeleteCrResponses, LenderFirmsCreateDeleteCrErrors, LenderFirmsGetDataData, LenderFirmsGetDataResponses, LenderFirmsGetDataErrors, LenderFirmsAddOrUpdateDataData, LenderFirmsAddOrUpdateDataResponses, LenderFirmsAddOrUpdateDataErrors, LenderFirmsDeleteDataData, LenderFirmsDeleteDataResponses, LenderFirmsDeleteDataErrors, LenderFirmsGetResultData, LenderFirmsGetResultResponses, LenderFirmsGetResultErrors, LendersGetLenderData, LendersGetLenderResponses, LendersGetLenderErrors, LendersCreateChangeRequestData, LendersCreateChangeRequestResponses, LendersCreateChangeRequestErrors, NotesGetNotesData, NotesGetNotesResponses, NotesGetNotesErrors, NotesCreateNoteData, NotesCreateNoteResponses, NotesCreateNoteErrors, NotesDeleteNoteData, NotesDeleteNoteResponses, NotesDeleteNoteErrors, NotesUpdateNoteData, NotesUpdateNoteResponses, NotesUpdateNoteErrors, OptionsGetAllOptionsForFieldsData, OptionsGetAllOptionsForFieldsResponses, OptionsGetAllOptionsForFieldsErrors, PostcodeAreaGetAllData, PostcodeAreaGetAllResponses, PostcodeAreaGetAllErrors, PostcodeAreaGetByCodeData, PostcodeAreaGetByCodeResponses, PostcodeAreaGetByCodeErrors, ProcurationFeeAssignmentsGetAllDefaultProcFeeAssignmentsData, ProcurationFeeAssignmentsGetAllDefaultProcFeeAssignmentsResponses, ProcurationFeeAssignmentsGetAllDefaultProcFeeAssignmentsErrors, ProcurationFeeAssignmentsGetFirmProcFeeAssignmentsData, ProcurationFeeAssignmentsGetFirmProcFeeAssignmentsResponses, ProcurationFeeAssignmentsGetFirmProcFeeAssignmentsErrors, ProcurationFeeAssignmentsCreateChangeRequestData, ProcurationFeeAssignmentsCreateChangeRequestResponses, ProcurationFeeAssignmentsCreateChangeRequestErrors, ProcurationFeeAssignmentsValidateDeleteData, ProcurationFeeAssignmentsValidateDeleteResponses, ProcurationFeeAssignmentsValidateDeleteErrors, ProcurationFeeAssignmentsCreateDeleteCrData, ProcurationFeeAssignmentsCreateDeleteCrResponses, ProcurationFeeAssignmentsCreateDeleteCrErrors, ProcurationFeeAssignmentsCreateReorderChangeRequestData, ProcurationFeeAssignmentsCreateReorderChangeRequestResponses, ProcurationFeeAssignmentsCreateReorderChangeRequestErrors, ProcurationFeeAssignmentsGetDataData, ProcurationFeeAssignmentsGetDataResponses, ProcurationFeeAssignmentsGetDataErrors, ProcurationFeeAssignmentsAddOrUpdateDataData, ProcurationFeeAssignmentsAddOrUpdateDataResponses, ProcurationFeeAssignmentsAddOrUpdateDataErrors, ProcurationFeeAssignmentsDeleteDataData, ProcurationFeeAssignmentsDeleteDataResponses, ProcurationFeeAssignmentsDeleteDataErrors, ProcurationFeeAssignmentsGetResultData, ProcurationFeeAssignmentsGetResultResponses, ProcurationFeeAssignmentsGetResultErrors, ProcurationFeeRulesGetAllProcurationFeeRulesData, ProcurationFeeRulesGetAllProcurationFeeRulesResponses, ProcurationFeeRulesGetAllProcurationFeeRulesErrors, ProcurationFeeRulesCreateChangeRequestData, ProcurationFeeRulesCreateChangeRequestResponses, ProcurationFeeRulesCreateChangeRequestErrors, ProcurationFeeRulesCheckUsageData, ProcurationFeeRulesCheckUsageResponses, ProcurationFeeRulesCheckUsageErrors, ProcurationFeeRulesValidateDeleteData, ProcurationFeeRulesValidateDeleteResponses, ProcurationFeeRulesValidateDeleteErrors, ProcurationFeeRulesCreateDeleteCrData, ProcurationFeeRulesCreateDeleteCrResponses, ProcurationFeeRulesCreateDeleteCrErrors, ProcurationFeeRulesGetDataData, ProcurationFeeRulesGetDataResponses, ProcurationFeeRulesGetDataErrors, ProcurationFeeRulesAddOrUpdateDataData, ProcurationFeeRulesAddOrUpdateDataResponses, ProcurationFeeRulesAddOrUpdateDataErrors, ProcurationFeeRulesDeleteDataData, ProcurationFeeRulesDeleteDataResponses, ProcurationFeeRulesDeleteDataErrors, ProcurationFeeRulesGetResultData, ProcurationFeeRulesGetResultResponses, ProcurationFeeRulesGetResultErrors, ProcurationFeesGetAllProcurationFeesData, ProcurationFeesGetAllProcurationFeesResponses, ProcurationFeesGetAllProcurationFeesErrors, ProcurationFeesCreateChangeRequestData, ProcurationFeesCreateChangeRequestResponses, ProcurationFeesCreateChangeRequestErrors, ProcurationFeesCheckUsageData, ProcurationFeesCheckUsageResponses, ProcurationFeesCheckUsageErrors, ProcurationFeesValidateDeleteData, ProcurationFeesValidateDeleteResponses, ProcurationFeesValidateDeleteErrors, ProcurationFeesCreateDeleteCrData, ProcurationFeesCreateDeleteCrResponses, ProcurationFeesCreateDeleteCrErrors, ProcurationFeesGetDataData, ProcurationFeesGetDataResponses, ProcurationFeesGetDataErrors, ProcurationFeesAddOrUpdateDataData, ProcurationFeesAddOrUpdateDataResponses, ProcurationFeesAddOrUpdateDataErrors, ProcurationFeesDeleteDataData, ProcurationFeesDeleteDataResponses, ProcurationFeesDeleteDataErrors, ProcurationFeesGetResultData, ProcurationFeesGetResultResponses, ProcurationFeesGetResultErrors, ProductChangesGetDataData, ProductChangesGetDataResponses, ProductChangesGetDataErrors, ProductChangesAddOrUpdateDataData, ProductChangesAddOrUpdateDataResponses, ProductChangesAddOrUpdateDataErrors, ProductChangesDeleteDataData, ProductChangesDeleteDataResponses, ProductChangesDeleteDataErrors, ProductChangesSubmitForReviewData, ProductChangesSubmitForReviewResponses, ProductChangesSubmitForReviewErrors, ProductChangesGetResultData, ProductChangesGetResultResponses, ProductChangesGetResultErrors, ProductChangesApplyColumnDeltaData, ProductChangesApplyColumnDeltaResponses, ProductChangesApplyColumnDeltaErrors, ProductExclusivitySetsGetAllSetsData, ProductExclusivitySetsGetAllSetsResponses, ProductExclusivitySetsGetAllSetsErrors, ProductExclusivitySetsCreateChangeRequestData, ProductExclusivitySetsCreateChangeRequestResponses, ProductExclusivitySetsCreateChangeRequestErrors, ProductExclusivitySetsCheckUsageData, ProductExclusivitySetsCheckUsageResponses, ProductExclusivitySetsCheckUsageErrors, ProductExclusivitySetsValidateDeleteData, ProductExclusivitySetsValidateDeleteResponses, ProductExclusivitySetsValidateDeleteErrors, ProductExclusivitySetsCreateDeleteCrData, ProductExclusivitySetsCreateDeleteCrResponses, ProductExclusivitySetsCreateDeleteCrErrors, ProductExclusivitySetsGetDataData, ProductExclusivitySetsGetDataResponses, ProductExclusivitySetsGetDataErrors, ProductExclusivitySetsAddOrUpdateDataData, ProductExclusivitySetsAddOrUpdateDataResponses, ProductExclusivitySetsAddOrUpdateDataErrors, ProductExclusivitySetsDeleteDataData, ProductExclusivitySetsDeleteDataResponses, ProductExclusivitySetsDeleteDataErrors, ProductExclusivitySetsGetResultData, ProductExclusivitySetsGetResultResponses, ProductExclusivitySetsGetResultErrors, ProductsGetAllProductsData, ProductsGetAllProductsResponses, ProductsGetAllProductsErrors, ProductsGetProductCodesData, ProductsGetProductCodesResponses, ProductsGetProductCodesErrors, StaffGetAllData, StaffGetAllResponses, StaffGetByIdData, StaffGetByIdResponses, StaffGetByIdErrors, CreateTableViewData, CreateTableViewResponses, CreateTableViewErrors, GetTableViewsForADataTypeData, GetTableViewsForADataTypeResponses, DeleteTableViewData, DeleteTableViewResponses, DeleteTableViewErrors, UpdateTableViewsData, UpdateTableViewsResponses, UpdateTableViewsErrors, TranslationsGetTranslationsData, TranslationsGetTranslationsResponses, TranslationsGetTranslationsErrors, TranslationsGetTranslationData, TranslationsGetTranslationResponses, TranslationsGetTranslationErrors, UsersGetCurrentUserPermissionsData, UsersGetCurrentUserPermissionsResponses } from './types.gen';
import { client as _heyApiClient } from './client.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = ClientOptions<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

export const baseRatesGetAllBaseRates = <ThrowOnError extends boolean = true>(options?: Options<BaseRatesGetAllBaseRatesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<BaseRatesGetAllBaseRatesResponses, BaseRatesGetAllBaseRatesErrors, ThrowOnError>({
        url: '/baserates',
        ...options
    });
};

export const getBaseRate = <ThrowOnError extends boolean = true>(options: Options<GetBaseRateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetBaseRateResponses, GetBaseRateErrors, ThrowOnError>({
        url: '/baserates/{baseRateCode}',
        ...options
    });
};

export const baseRatesCreateChangeRequest = <ThrowOnError extends boolean = true>(options: Options<BaseRatesCreateChangeRequestData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<BaseRatesCreateChangeRequestResponses, BaseRatesCreateChangeRequestErrors, ThrowOnError>({
        url: '/baserates/create',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const baseRatesCheckBaseRateUsage = <ThrowOnError extends boolean = true>(options: Options<BaseRatesCheckBaseRateUsageData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<BaseRatesCheckBaseRateUsageResponses, BaseRatesCheckBaseRateUsageErrors, ThrowOnError>({
        url: '/baserates/{baseRateCode}/usage',
        ...options
    });
};

export const baseRatesValidateDelete = <ThrowOnError extends boolean = true>(options: Options<BaseRatesValidateDeleteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<BaseRatesValidateDeleteResponses, BaseRatesValidateDeleteErrors, ThrowOnError>({
        url: '/baserates/validate-delete',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const baseRatesCreateDeleteCr = <ThrowOnError extends boolean = true>(options: Options<BaseRatesCreateDeleteCrData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<BaseRatesCreateDeleteCrResponses, BaseRatesCreateDeleteCrErrors, ThrowOnError>({
        url: '/baserates/delete-cr',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const baseRatesGetData = <ThrowOnError extends boolean = true>(options: Options<BaseRatesGetDataData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<BaseRatesGetDataResponses, BaseRatesGetDataErrors, ThrowOnError>({
        url: '/baserates/{actionId}/data',
        ...options
    });
};

export const baseRatesAddOrUpdateData = <ThrowOnError extends boolean = true>(options: Options<BaseRatesAddOrUpdateDataData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<BaseRatesAddOrUpdateDataResponses, BaseRatesAddOrUpdateDataErrors, ThrowOnError>({
        url: '/baserates/{actionId}/data',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const baseRatesDeleteData = <ThrowOnError extends boolean = true>(options: Options<BaseRatesDeleteDataData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<BaseRatesDeleteDataResponses, unknown, ThrowOnError>({
        url: '/baserates/{actionId}/data/{rowNumbers}',
        ...options
    });
};

export const baseRatesGetResult = <ThrowOnError extends boolean = true>(options: Options<BaseRatesGetResultData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<BaseRatesGetResultResponses, BaseRatesGetResultErrors, ThrowOnError>({
        url: '/baserates/{actionId}/result',
        ...options
    });
};

export const bdmGetAll = <ThrowOnError extends boolean = true>(options?: Options<BdmGetAllData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<BdmGetAllResponses, BdmGetAllErrors, ThrowOnError>({
        url: '/bdms',
        ...options
    });
};

export const bdmGetById = <ThrowOnError extends boolean = true>(options: Options<BdmGetByIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<BdmGetByIdResponses, BdmGetByIdErrors, ThrowOnError>({
        url: '/bdms/{id}',
        ...options
    });
};

export const changeRequestCreateDraft = <ThrowOnError extends boolean = true>(options: Options<ChangeRequestCreateDraftData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ChangeRequestCreateDraftResponses, ChangeRequestCreateDraftErrors, ThrowOnError>({
        url: '/changeRequests',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const changeRequestGet = <ThrowOnError extends boolean = true>(options: Options<ChangeRequestGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ChangeRequestGetResponses, ChangeRequestGetErrors, ThrowOnError>({
        url: '/changeRequests/{actionId}',
        ...options
    });
};

export const changeRequestGetLatestChangeRequests = <ThrowOnError extends boolean = true>(options?: Options<ChangeRequestGetLatestChangeRequestsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ChangeRequestGetLatestChangeRequestsResponses, ChangeRequestGetLatestChangeRequestsErrors, ThrowOnError>({
        url: '/changeRequests/list',
        ...options
    });
};

export const changeRequestApprove = <ThrowOnError extends boolean = true>(options: Options<ChangeRequestApproveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ChangeRequestApproveResponses, ChangeRequestApproveErrors, ThrowOnError>({
        url: '/changeRequests/{changeRequestId}/approve',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const changeRequestReject = <ThrowOnError extends boolean = true>(options: Options<ChangeRequestRejectData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ChangeRequestRejectResponses, ChangeRequestRejectErrors, ThrowOnError>({
        url: '/changeRequests/{changeRequestId}/reject',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const changeRequestResubmissionRequired = <ThrowOnError extends boolean = true>(options: Options<ChangeRequestResubmissionRequiredData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ChangeRequestResubmissionRequiredResponses, ChangeRequestResubmissionRequiredErrors, ThrowOnError>({
        url: '/changeRequests/{changeRequestId}/resubmission-required',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const changeRequestApplyChangeRequest = <ThrowOnError extends boolean = true>(options: Options<ChangeRequestApplyChangeRequestData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ChangeRequestApplyChangeRequestResponses, ChangeRequestApplyChangeRequestErrors, ThrowOnError>({
        url: '/changeRequests/{changeRequestId}/apply',
        ...options
    });
};

export const changeRequestFlipBetweenCloneAndReplace = <ThrowOnError extends boolean = true>(options: Options<ChangeRequestFlipBetweenCloneAndReplaceData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<ChangeRequestFlipBetweenCloneAndReplaceResponses, ChangeRequestFlipBetweenCloneAndReplaceErrors, ThrowOnError>({
        url: '/changeRequests/{changeRequestId}/flipBetweenCloneAndReplace',
        ...options
    });
};

export const changeRequestDelete = <ThrowOnError extends boolean = true>(options: Options<ChangeRequestDeleteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ChangeRequestDeleteResponses, ChangeRequestDeleteErrors, ThrowOnError>({
        url: '/changeRequests/{changeRequestId}/delete',
        ...options
    });
};

export const configurationsGetConfiguration = <ThrowOnError extends boolean = true>(options?: Options<ConfigurationsGetConfigurationData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ConfigurationsGetConfigurationResponses, unknown, ThrowOnError>({
        url: '/configuration/configuration',
        ...options
    });
};

export const getAllBrands = <ThrowOnError extends boolean = true>(options?: Options<GetAllBrandsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetAllBrandsResponses, unknown, ThrowOnError>({
        url: '/configuration/brands',
        ...options
    });
};

export const getAllAdditionalFields = <ThrowOnError extends boolean = true>(options?: Options<GetAllAdditionalFieldsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetAllAdditionalFieldsResponses, unknown, ThrowOnError>({
        url: '/configuration/additionalFields',
        ...options
    });
};

export const ercProfilesGetAllErcProfiles = <ThrowOnError extends boolean = true>(options?: Options<ErcProfilesGetAllErcProfilesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ErcProfilesGetAllErcProfilesResponses, ErcProfilesGetAllErcProfilesErrors, ThrowOnError>({
        url: '/ercprofiles',
        ...options
    });
};

export const ercProfilesCheckUsage = <ThrowOnError extends boolean = true>(options: Options<ErcProfilesCheckUsageData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ErcProfilesCheckUsageResponses, ErcProfilesCheckUsageErrors, ThrowOnError>({
        url: '/ercprofiles/{ercProfileId}/usage',
        ...options
    });
};

export const ercProfilesCreateChangeRequest = <ThrowOnError extends boolean = true>(options: Options<ErcProfilesCreateChangeRequestData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ErcProfilesCreateChangeRequestResponses, ErcProfilesCreateChangeRequestErrors, ThrowOnError>({
        url: '/ercprofiles/create',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const ercProfilesValidateDelete = <ThrowOnError extends boolean = true>(options: Options<ErcProfilesValidateDeleteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ErcProfilesValidateDeleteResponses, ErcProfilesValidateDeleteErrors, ThrowOnError>({
        url: '/ercprofiles/validate-delete',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const ercProfilesCreateDeleteCr = <ThrowOnError extends boolean = true>(options: Options<ErcProfilesCreateDeleteCrData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ErcProfilesCreateDeleteCrResponses, ErcProfilesCreateDeleteCrErrors, ThrowOnError>({
        url: '/ercprofiles/delete-cr',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const ercProfilesGetData = <ThrowOnError extends boolean = true>(options: Options<ErcProfilesGetDataData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ErcProfilesGetDataResponses, ErcProfilesGetDataErrors, ThrowOnError>({
        url: '/ercprofiles/{actionId}/data',
        ...options
    });
};

export const ercProfilesAddOrUpdateData = <ThrowOnError extends boolean = true>(options: Options<ErcProfilesAddOrUpdateDataData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ErcProfilesAddOrUpdateDataResponses, ErcProfilesAddOrUpdateDataErrors, ThrowOnError>({
        url: '/ercprofiles/{actionId}/data',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const ercProfilesDeleteData = <ThrowOnError extends boolean = true>(options: Options<ErcProfilesDeleteDataData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<ErcProfilesDeleteDataResponses, ErcProfilesDeleteDataErrors, ThrowOnError>({
        url: '/ercprofiles/{actionId}/data/{rowNumbers}',
        ...options
    });
};

export const ercProfilesGetResult = <ThrowOnError extends boolean = true>(options: Options<ErcProfilesGetResultData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ErcProfilesGetResultResponses, ErcProfilesGetResultErrors, ThrowOnError>({
        url: '/ercprofiles/{actionId}/result',
        ...options
    });
};

export const exchangeRatesGetAllExchangeRates = <ThrowOnError extends boolean = true>(options?: Options<ExchangeRatesGetAllExchangeRatesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ExchangeRatesGetAllExchangeRatesResponses, ExchangeRatesGetAllExchangeRatesErrors, ThrowOnError>({
        url: '/exchange-rates',
        ...options
    });
};

export const exchangeRatesCreateChangeRequest = <ThrowOnError extends boolean = true>(options: Options<ExchangeRatesCreateChangeRequestData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ExchangeRatesCreateChangeRequestResponses, ExchangeRatesCreateChangeRequestErrors, ThrowOnError>({
        url: '/exchange-rates/create',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const exchangeRatesValidateDelete = <ThrowOnError extends boolean = true>(options: Options<ExchangeRatesValidateDeleteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ExchangeRatesValidateDeleteResponses, ExchangeRatesValidateDeleteErrors, ThrowOnError>({
        url: '/exchange-rates/validate-delete',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const exchangeRatesCreateDeleteCr = <ThrowOnError extends boolean = true>(options: Options<ExchangeRatesCreateDeleteCrData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ExchangeRatesCreateDeleteCrResponses, ExchangeRatesCreateDeleteCrErrors, ThrowOnError>({
        url: '/exchange-rates/delete-cr',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const exchangeRatesGetData = <ThrowOnError extends boolean = true>(options: Options<ExchangeRatesGetDataData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ExchangeRatesGetDataResponses, ExchangeRatesGetDataErrors, ThrowOnError>({
        url: '/exchange-rates/{actionId}/data',
        ...options
    });
};

export const exchangeRatesAddOrUpdateData = <ThrowOnError extends boolean = true>(options: Options<ExchangeRatesAddOrUpdateDataData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ExchangeRatesAddOrUpdateDataResponses, ExchangeRatesAddOrUpdateDataErrors, ThrowOnError>({
        url: '/exchange-rates/{actionId}/data',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const exchangeRatesDeleteData = <ThrowOnError extends boolean = true>(options: Options<ExchangeRatesDeleteDataData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<ExchangeRatesDeleteDataResponses, ExchangeRatesDeleteDataErrors, ThrowOnError>({
        url: '/exchange-rates/{actionId}/data/{rowNumbers}',
        ...options
    });
};

export const exchangeRatesGetResult = <ThrowOnError extends boolean = true>(options: Options<ExchangeRatesGetResultData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ExchangeRatesGetResultResponses, ExchangeRatesGetResultErrors, ThrowOnError>({
        url: '/exchange-rates/{actionId}/result',
        ...options
    });
};

export const getAllExportTemplates = <ThrowOnError extends boolean = true>(options?: Options<GetAllExportTemplatesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetAllExportTemplatesResponses, unknown, ThrowOnError>({
        url: '/exportTemplates',
        ...options
    });
};

export const createExportTemplate = <ThrowOnError extends boolean = true>(options: Options<CreateExportTemplateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateExportTemplateResponses, CreateExportTemplateErrors, ThrowOnError>({
        url: '/exportTemplates',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const deleteExportTemplate = <ThrowOnError extends boolean = true>(options: Options<DeleteExportTemplateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteExportTemplateResponses, DeleteExportTemplateErrors, ThrowOnError>({
        url: '/exportTemplates/{templateId}',
        ...options
    });
};

export const updateExportTemplate = <ThrowOnError extends boolean = true>(options: Options<UpdateExportTemplateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpdateExportTemplateResponses, UpdateExportTemplateErrors, ThrowOnError>({
        url: '/exportTemplates/{templateId}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const feeDefinitionsGetAllFeeDefinitions = <ThrowOnError extends boolean = true>(options?: Options<FeeDefinitionsGetAllFeeDefinitionsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<FeeDefinitionsGetAllFeeDefinitionsResponses, FeeDefinitionsGetAllFeeDefinitionsErrors, ThrowOnError>({
        url: '/feedefinitions',
        ...options
    });
};

export const feeDefinitionsCheckUsage = <ThrowOnError extends boolean = true>(options: Options<FeeDefinitionsCheckUsageData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<FeeDefinitionsCheckUsageResponses, FeeDefinitionsCheckUsageErrors, ThrowOnError>({
        url: '/feedefinitions/{feeId}/usage',
        ...options
    });
};

export const feeDefinitionsCreateChangeRequest = <ThrowOnError extends boolean = true>(options: Options<FeeDefinitionsCreateChangeRequestData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<FeeDefinitionsCreateChangeRequestResponses, FeeDefinitionsCreateChangeRequestErrors, ThrowOnError>({
        url: '/feedefinitions/create',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const feeDefinitionsValidateDelete = <ThrowOnError extends boolean = true>(options: Options<FeeDefinitionsValidateDeleteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<FeeDefinitionsValidateDeleteResponses, FeeDefinitionsValidateDeleteErrors, ThrowOnError>({
        url: '/feedefinitions/validate-delete',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const feeDefinitionsCreateDeleteCr = <ThrowOnError extends boolean = true>(options: Options<FeeDefinitionsCreateDeleteCrData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<FeeDefinitionsCreateDeleteCrResponses, FeeDefinitionsCreateDeleteCrErrors, ThrowOnError>({
        url: '/feedefinitions/delete-cr',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const feeDefinitionsGetData = <ThrowOnError extends boolean = true>(options: Options<FeeDefinitionsGetDataData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<FeeDefinitionsGetDataResponses, FeeDefinitionsGetDataErrors, ThrowOnError>({
        url: '/feedefinitions/{actionId}/data',
        ...options
    });
};

export const feeDefinitionsAddOrUpdateData = <ThrowOnError extends boolean = true>(options: Options<FeeDefinitionsAddOrUpdateDataData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<FeeDefinitionsAddOrUpdateDataResponses, FeeDefinitionsAddOrUpdateDataErrors, ThrowOnError>({
        url: '/feedefinitions/{actionId}/data',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const feeDefinitionsDeleteData = <ThrowOnError extends boolean = true>(options: Options<FeeDefinitionsDeleteDataData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<FeeDefinitionsDeleteDataResponses, FeeDefinitionsDeleteDataErrors, ThrowOnError>({
        url: '/feedefinitions/{actionId}/data/{rowNumbers}',
        ...options
    });
};

export const feeDefinitionsGetResult = <ThrowOnError extends boolean = true>(options: Options<FeeDefinitionsGetResultData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<FeeDefinitionsGetResultResponses, FeeDefinitionsGetResultErrors, ThrowOnError>({
        url: '/feedefinitions/{actionId}/result',
        ...options
    });
};

export const feeProfilesGetAllFeeProfiles = <ThrowOnError extends boolean = true>(options?: Options<FeeProfilesGetAllFeeProfilesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<FeeProfilesGetAllFeeProfilesResponses, FeeProfilesGetAllFeeProfilesErrors, ThrowOnError>({
        url: '/feeprofiles',
        ...options
    });
};

export const feeProfilesCheckUsage = <ThrowOnError extends boolean = true>(options: Options<FeeProfilesCheckUsageData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<FeeProfilesCheckUsageResponses, FeeProfilesCheckUsageErrors, ThrowOnError>({
        url: '/feeprofiles/{feeProfileId}/usage',
        ...options
    });
};

export const feeProfilesCreateChangeRequest = <ThrowOnError extends boolean = true>(options: Options<FeeProfilesCreateChangeRequestData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<FeeProfilesCreateChangeRequestResponses, FeeProfilesCreateChangeRequestErrors, ThrowOnError>({
        url: '/feeprofiles/create',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const feeProfilesValidateDelete = <ThrowOnError extends boolean = true>(options: Options<FeeProfilesValidateDeleteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<FeeProfilesValidateDeleteResponses, FeeProfilesValidateDeleteErrors, ThrowOnError>({
        url: '/feeprofiles/validate-delete',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const feeProfilesCreateDeleteCr = <ThrowOnError extends boolean = true>(options: Options<FeeProfilesCreateDeleteCrData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<FeeProfilesCreateDeleteCrResponses, FeeProfilesCreateDeleteCrErrors, ThrowOnError>({
        url: '/feeprofiles/delete-cr',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const feeProfilesGetData = <ThrowOnError extends boolean = true>(options: Options<FeeProfilesGetDataData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<FeeProfilesGetDataResponses, FeeProfilesGetDataErrors, ThrowOnError>({
        url: '/feeprofiles/{actionId}/data',
        ...options
    });
};

export const feeProfilesAddOrUpdateData = <ThrowOnError extends boolean = true>(options: Options<FeeProfilesAddOrUpdateDataData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<FeeProfilesAddOrUpdateDataResponses, FeeProfilesAddOrUpdateDataErrors, ThrowOnError>({
        url: '/feeprofiles/{actionId}/data',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const feeProfilesDeleteData = <ThrowOnError extends boolean = true>(options: Options<FeeProfilesDeleteDataData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<FeeProfilesDeleteDataResponses, FeeProfilesDeleteDataErrors, ThrowOnError>({
        url: '/feeprofiles/{actionId}/data/{rowNumbers}',
        ...options
    });
};

export const feeProfilesGetResult = <ThrowOnError extends boolean = true>(options: Options<FeeProfilesGetResultData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<FeeProfilesGetResultResponses, FeeProfilesGetResultErrors, ThrowOnError>({
        url: '/feeprofiles/{actionId}/result',
        ...options
    });
};

export const firmProcFeeAssignmentsGetAllFirmAssignments = <ThrowOnError extends boolean = true>(options: Options<FirmProcFeeAssignmentsGetAllFirmAssignmentsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<FirmProcFeeAssignmentsGetAllFirmAssignmentsResponses, FirmProcFeeAssignmentsGetAllFirmAssignmentsErrors, ThrowOnError>({
        url: '/firm-proc-fee-assignments/{firmId}',
        ...options
    });
};

export const firmProcFeeAssignmentsCreateChangeRequest = <ThrowOnError extends boolean = true>(options: Options<FirmProcFeeAssignmentsCreateChangeRequestData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<FirmProcFeeAssignmentsCreateChangeRequestResponses, FirmProcFeeAssignmentsCreateChangeRequestErrors, ThrowOnError>({
        url: '/firm-proc-fee-assignments',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const firmProcFeeAssignmentsValidateDelete = <ThrowOnError extends boolean = true>(options: Options<FirmProcFeeAssignmentsValidateDeleteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<FirmProcFeeAssignmentsValidateDeleteResponses, FirmProcFeeAssignmentsValidateDeleteErrors, ThrowOnError>({
        url: '/firm-proc-fee-assignments/firm/{firmId}/validate-delete',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const firmProcFeeAssignmentsCreateDeleteCr = <ThrowOnError extends boolean = true>(options: Options<FirmProcFeeAssignmentsCreateDeleteCrData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<FirmProcFeeAssignmentsCreateDeleteCrResponses, FirmProcFeeAssignmentsCreateDeleteCrErrors, ThrowOnError>({
        url: '/firm-proc-fee-assignments/firm/{firmId}/delete-cr',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const firmProcFeeAssignmentsCreateFirmReorderChangeRequest = <ThrowOnError extends boolean = true>(options: Options<FirmProcFeeAssignmentsCreateFirmReorderChangeRequestData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<FirmProcFeeAssignmentsCreateFirmReorderChangeRequestResponses, FirmProcFeeAssignmentsCreateFirmReorderChangeRequestErrors, ThrowOnError>({
        url: '/firm-proc-fee-assignments/firm/{firmId}/proc-fee-assignments/reorder',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const firmProcFeeAssignmentsGetData = <ThrowOnError extends boolean = true>(options: Options<FirmProcFeeAssignmentsGetDataData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<FirmProcFeeAssignmentsGetDataResponses, FirmProcFeeAssignmentsGetDataErrors, ThrowOnError>({
        url: '/firm-proc-fee-assignments/{actionId}/data',
        ...options
    });
};

export const firmProcFeeAssignmentsAddOrUpdateData = <ThrowOnError extends boolean = true>(options: Options<FirmProcFeeAssignmentsAddOrUpdateDataData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<FirmProcFeeAssignmentsAddOrUpdateDataResponses, FirmProcFeeAssignmentsAddOrUpdateDataErrors, ThrowOnError>({
        url: '/firm-proc-fee-assignments/{actionId}/data',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const firmProcFeeAssignmentsDeleteData = <ThrowOnError extends boolean = true>(options: Options<FirmProcFeeAssignmentsDeleteDataData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<FirmProcFeeAssignmentsDeleteDataResponses, FirmProcFeeAssignmentsDeleteDataErrors, ThrowOnError>({
        url: '/firm-proc-fee-assignments/{actionId}/data/{rowNumbers}',
        ...options
    });
};

export const firmProcFeeAssignmentsGetResult = <ThrowOnError extends boolean = true>(options: Options<FirmProcFeeAssignmentsGetResultData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<FirmProcFeeAssignmentsGetResultResponses, FirmProcFeeAssignmentsGetResultErrors, ThrowOnError>({
        url: '/firm-proc-fee-assignments/{actionId}/result',
        ...options
    });
};

export const updateImportMatching = <ThrowOnError extends boolean = true>(options: Options<UpdateImportMatchingData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpdateImportMatchingResponses, unknown, ThrowOnError>({
        url: '/importMatching',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const importMatchingGetImportMatchingOfType = <ThrowOnError extends boolean = true>(options: Options<ImportMatchingGetImportMatchingOfTypeData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ImportMatchingGetImportMatchingOfTypeResponses, unknown, ThrowOnError>({
        url: '/importMatching/{importEntityType}',
        ...options
    });
};

export const importSchemasGetImportSchemas = <ThrowOnError extends boolean = true>(options?: Options<ImportSchemasGetImportSchemasData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ImportSchemasGetImportSchemasResponses, ImportSchemasGetImportSchemasErrors, ThrowOnError>({
        url: '/import-schemas',
        ...options
    });
};

export const importSchemasGetAnImportSchema = <ThrowOnError extends boolean = true>(options: Options<ImportSchemasGetAnImportSchemaData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ImportSchemasGetAnImportSchemaResponses, ImportSchemasGetAnImportSchemaErrors, ThrowOnError>({
        url: '/import-schemas/{importEntityType}',
        ...options
    });
};

export const importsCreateImport = <ThrowOnError extends boolean = true>(options: Options<ImportsCreateImportData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ImportsCreateImportResponses, ImportsCreateImportErrors, ThrowOnError>({
        url: '/imports',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const importsDeleteImport = <ThrowOnError extends boolean = true>(options: Options<ImportsDeleteImportData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<ImportsDeleteImportResponses, ImportsDeleteImportErrors, ThrowOnError>({
        url: '/imports/{importId}',
        ...options
    });
};

export const importsGetImport = <ThrowOnError extends boolean = true>(options: Options<ImportsGetImportData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ImportsGetImportResponses, ImportsGetImportErrors, ThrowOnError>({
        url: '/imports/{importId}',
        ...options
    });
};

export const importsRecreateImport = <ThrowOnError extends boolean = true>(options: Options<ImportsRecreateImportData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<ImportsRecreateImportResponses, ImportsRecreateImportErrors, ThrowOnError>({
        url: '/imports/{importId}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const importsGetLatestImports = <ThrowOnError extends boolean = true>(options?: Options<ImportsGetLatestImportsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ImportsGetLatestImportsResponses, ImportsGetLatestImportsErrors, ThrowOnError>({
        url: '/imports/list',
        ...options
    });
};

export const importsGetImportData = <ThrowOnError extends boolean = true>(options: Options<ImportsGetImportDataData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ImportsGetImportDataResponses, ImportsGetImportDataErrors, ThrowOnError>({
        url: '/imports/{importId}/data',
        ...options
    });
};

export const importsAddImportRows = <ThrowOnError extends boolean = true>(options: Options<ImportsAddImportRowsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ImportsAddImportRowsResponses, ImportsAddImportRowsErrors, ThrowOnError>({
        url: '/imports/{importId}/data',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const importsUpdateImportCell = <ThrowOnError extends boolean = true>(options: Options<ImportsUpdateImportCellData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<ImportsUpdateImportCellResponses, ImportsUpdateImportCellErrors, ThrowOnError>({
        url: '/imports/{importId}/data',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const importsDeleteImportRows = <ThrowOnError extends boolean = true>(options: Options<ImportsDeleteImportRowsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<ImportsDeleteImportRowsResponses, ImportsDeleteImportRowsErrors, ThrowOnError>({
        url: '/imports/{importId}/data/{rowNumbers}',
        ...options
    });
};

export const importsValidateImport = <ThrowOnError extends boolean = true>(options: Options<ImportsValidateImportData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ImportsValidateImportResponses, ImportsValidateImportErrors, ThrowOnError>({
        url: '/imports/{importId}/errors',
        ...options
    });
};

export const importsSubmitForReview = <ThrowOnError extends boolean = true>(options: Options<ImportsSubmitForReviewData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ImportsSubmitForReviewResponses, ImportsSubmitForReviewErrors, ThrowOnError>({
        url: '/imports/{importId}/submit-for-review',
        ...options
    });
};

export const interestRatesCreateChangeRequest = <ThrowOnError extends boolean = true>(options: Options<InterestRatesCreateChangeRequestData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<InterestRatesCreateChangeRequestResponses, InterestRatesCreateChangeRequestErrors, ThrowOnError>({
        url: '/interest-rates/create',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const interestRatesValidateIrDelete = <ThrowOnError extends boolean = true>(options: Options<InterestRatesValidateIrDeleteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<InterestRatesValidateIrDeleteResponses, InterestRatesValidateIrDeleteErrors, ThrowOnError>({
        url: '/interest-rates/interest-rates/validate-delete',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const interestRatesCreateIrDeleteCr = <ThrowOnError extends boolean = true>(options: Options<InterestRatesCreateIrDeleteCrData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<InterestRatesCreateIrDeleteCrResponses, InterestRatesCreateIrDeleteCrErrors, ThrowOnError>({
        url: '/interest-rates/interest-rates/delete-cr',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const interestRatesGetData = <ThrowOnError extends boolean = true>(options: Options<InterestRatesGetDataData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<InterestRatesGetDataResponses, InterestRatesGetDataErrors, ThrowOnError>({
        url: '/interest-rates/{actionId}/data',
        ...options
    });
};

export const interestRatesAddOrUpdateData = <ThrowOnError extends boolean = true>(options: Options<InterestRatesAddOrUpdateDataData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<InterestRatesAddOrUpdateDataResponses, InterestRatesAddOrUpdateDataErrors, ThrowOnError>({
        url: '/interest-rates/{actionId}/data',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const interestRatesDeleteData = <ThrowOnError extends boolean = true>(options: Options<InterestRatesDeleteDataData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<InterestRatesDeleteDataResponses, InterestRatesDeleteDataErrors, ThrowOnError>({
        url: '/interest-rates/{actionId}/data/{rowNumbers}',
        ...options
    });
};

export const interestRatesGetResult = <ThrowOnError extends boolean = true>(options: Options<InterestRatesGetResultData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<InterestRatesGetResultResponses, InterestRatesGetResultErrors, ThrowOnError>({
        url: '/interest-rates/{actionId}/result',
        ...options
    });
};

export const intermediaryGetAll = <ThrowOnError extends boolean = true>(options?: Options<IntermediaryGetAllData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<IntermediaryGetAllResponses, IntermediaryGetAllErrors, ThrowOnError>({
        url: '/intermediaries',
        ...options
    });
};

export const intermediaryCreateChangeRequest = <ThrowOnError extends boolean = true>(options: Options<IntermediaryCreateChangeRequestData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<IntermediaryCreateChangeRequestResponses, IntermediaryCreateChangeRequestErrors, ThrowOnError>({
        url: '/intermediaries',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const intermediaryGetById = <ThrowOnError extends boolean = true>(options: Options<IntermediaryGetByIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<IntermediaryGetByIdResponses, IntermediaryGetByIdErrors, ThrowOnError>({
        url: '/intermediaries/{id}',
        ...options
    });
};

export const intermediarySendInvitationEmail = <ThrowOnError extends boolean = true>(options: Options<IntermediarySendInvitationEmailData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<IntermediarySendInvitationEmailResponses, IntermediarySendInvitationEmailErrors, ThrowOnError>({
        url: '/intermediaries/{id}/send-invite-email',
        ...options
    });
};

export const intermediaryGetIntermediaryFcaData = <ThrowOnError extends boolean = true>(options: Options<IntermediaryGetIntermediaryFcaDataData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<IntermediaryGetIntermediaryFcaDataResponses, IntermediaryGetIntermediaryFcaDataErrors, ThrowOnError>({
        url: '/intermediaries/fca-data/{irn}',
        ...options
    });
};

export const intermediaryValidateDelete = <ThrowOnError extends boolean = true>(options: Options<IntermediaryValidateDeleteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<IntermediaryValidateDeleteResponses, IntermediaryValidateDeleteErrors, ThrowOnError>({
        url: '/intermediaries/validate-delete',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const intermediaryCreateDeleteCr = <ThrowOnError extends boolean = true>(options: Options<IntermediaryCreateDeleteCrData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<IntermediaryCreateDeleteCrResponses, IntermediaryCreateDeleteCrErrors, ThrowOnError>({
        url: '/intermediaries/delete-cr',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const intermediaryGetData = <ThrowOnError extends boolean = true>(options: Options<IntermediaryGetDataData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<IntermediaryGetDataResponses, IntermediaryGetDataErrors, ThrowOnError>({
        url: '/intermediaries/{actionId}/data',
        ...options
    });
};

export const intermediaryAddOrUpdateData = <ThrowOnError extends boolean = true>(options: Options<IntermediaryAddOrUpdateDataData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<IntermediaryAddOrUpdateDataResponses, IntermediaryAddOrUpdateDataErrors, ThrowOnError>({
        url: '/intermediaries/{actionId}/data',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const intermediaryDeleteData = <ThrowOnError extends boolean = true>(options: Options<IntermediaryDeleteDataData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<IntermediaryDeleteDataResponses, IntermediaryDeleteDataErrors, ThrowOnError>({
        url: '/intermediaries/{actionId}/data/{rowNumbers}',
        ...options
    });
};

export const intermediaryGetResult = <ThrowOnError extends boolean = true>(options: Options<IntermediaryGetResultData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<IntermediaryGetResultResponses, IntermediaryGetResultErrors, ThrowOnError>({
        url: '/intermediaries/{actionId}/result',
        ...options
    });
};

export const lenderFirmsGetAllLenderFirms = <ThrowOnError extends boolean = true>(options?: Options<LenderFirmsGetAllLenderFirmsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<LenderFirmsGetAllLenderFirmsResponses, LenderFirmsGetAllLenderFirmsErrors, ThrowOnError>({
        url: '/lender-firms',
        ...options
    });
};

export const lenderFirmsCreateChangeRequest = <ThrowOnError extends boolean = true>(options: Options<LenderFirmsCreateChangeRequestData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<LenderFirmsCreateChangeRequestResponses, LenderFirmsCreateChangeRequestErrors, ThrowOnError>({
        url: '/lender-firms',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const lenderFirmsGetLenderFirm = <ThrowOnError extends boolean = true>(options: Options<LenderFirmsGetLenderFirmData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<LenderFirmsGetLenderFirmResponses, LenderFirmsGetLenderFirmErrors, ThrowOnError>({
        url: '/lender-firms/{firmId}',
        ...options
    });
};

export const lenderFirmsGetFirmFcaData = <ThrowOnError extends boolean = true>(options: Options<LenderFirmsGetFirmFcaDataData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<LenderFirmsGetFirmFcaDataResponses, LenderFirmsGetFirmFcaDataErrors, ThrowOnError>({
        url: '/lender-firms/fca-data/{frn}',
        ...options
    });
};

export const lenderFirmsGetTradingAddresses = <ThrowOnError extends boolean = true>(options: Options<LenderFirmsGetTradingAddressesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<LenderFirmsGetTradingAddressesResponses, LenderFirmsGetTradingAddressesErrors, ThrowOnError>({
        url: '/lender-firms/{firmId}/trading-addresses',
        ...options
    });
};

export const lenderFirmsValidateDelete = <ThrowOnError extends boolean = true>(options: Options<LenderFirmsValidateDeleteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<LenderFirmsValidateDeleteResponses, LenderFirmsValidateDeleteErrors, ThrowOnError>({
        url: '/lender-firms/validate-delete',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const lenderFirmsCreateDeleteCr = <ThrowOnError extends boolean = true>(options: Options<LenderFirmsCreateDeleteCrData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<LenderFirmsCreateDeleteCrResponses, LenderFirmsCreateDeleteCrErrors, ThrowOnError>({
        url: '/lender-firms/delete-cr',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const lenderFirmsGetData = <ThrowOnError extends boolean = true>(options: Options<LenderFirmsGetDataData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<LenderFirmsGetDataResponses, LenderFirmsGetDataErrors, ThrowOnError>({
        url: '/lender-firms/{actionId}/data',
        ...options
    });
};

export const lenderFirmsAddOrUpdateData = <ThrowOnError extends boolean = true>(options: Options<LenderFirmsAddOrUpdateDataData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<LenderFirmsAddOrUpdateDataResponses, LenderFirmsAddOrUpdateDataErrors, ThrowOnError>({
        url: '/lender-firms/{actionId}/data',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const lenderFirmsDeleteData = <ThrowOnError extends boolean = true>(options: Options<LenderFirmsDeleteDataData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<LenderFirmsDeleteDataResponses, LenderFirmsDeleteDataErrors, ThrowOnError>({
        url: '/lender-firms/{actionId}/data/{rowNumbers}',
        ...options
    });
};

export const lenderFirmsGetResult = <ThrowOnError extends boolean = true>(options: Options<LenderFirmsGetResultData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<LenderFirmsGetResultResponses, LenderFirmsGetResultErrors, ThrowOnError>({
        url: '/lender-firms/{actionId}/result',
        ...options
    });
};

export const lendersGetLender = <ThrowOnError extends boolean = true>(options?: Options<LendersGetLenderData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<LendersGetLenderResponses, LendersGetLenderErrors, ThrowOnError>({
        url: '/lenders',
        ...options
    });
};

export const lendersCreateChangeRequest = <ThrowOnError extends boolean = true>(options: Options<LendersCreateChangeRequestData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<LendersCreateChangeRequestResponses, LendersCreateChangeRequestErrors, ThrowOnError>({
        url: '/lenders/changes/create',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const notesGetNotes = <ThrowOnError extends boolean = true>(options?: Options<NotesGetNotesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<NotesGetNotesResponses, NotesGetNotesErrors, ThrowOnError>({
        url: '/notes',
        ...options
    });
};

export const notesCreateNote = <ThrowOnError extends boolean = true>(options: Options<NotesCreateNoteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<NotesCreateNoteResponses, NotesCreateNoteErrors, ThrowOnError>({
        url: '/notes',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const notesDeleteNote = <ThrowOnError extends boolean = true>(options: Options<NotesDeleteNoteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<NotesDeleteNoteResponses, NotesDeleteNoteErrors, ThrowOnError>({
        url: '/notes/{noteId}',
        ...options
    });
};

export const notesUpdateNote = <ThrowOnError extends boolean = true>(options: Options<NotesUpdateNoteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<NotesUpdateNoteResponses, NotesUpdateNoteErrors, ThrowOnError>({
        url: '/notes/{noteId}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const optionsGetAllOptionsForFields = <ThrowOnError extends boolean = true>(options?: Options<OptionsGetAllOptionsForFieldsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<OptionsGetAllOptionsForFieldsResponses, OptionsGetAllOptionsForFieldsErrors, ThrowOnError>({
        url: '/options',
        ...options
    });
};

export const postcodeAreaGetAll = <ThrowOnError extends boolean = true>(options?: Options<PostcodeAreaGetAllData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<PostcodeAreaGetAllResponses, PostcodeAreaGetAllErrors, ThrowOnError>({
        url: '/postcode-areas',
        ...options
    });
};

export const postcodeAreaGetByCode = <ThrowOnError extends boolean = true>(options: Options<PostcodeAreaGetByCodeData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<PostcodeAreaGetByCodeResponses, PostcodeAreaGetByCodeErrors, ThrowOnError>({
        url: '/postcode-areas/{code}',
        ...options
    });
};

export const procurationFeeAssignmentsGetAllDefaultProcFeeAssignments = <ThrowOnError extends boolean = true>(options?: Options<ProcurationFeeAssignmentsGetAllDefaultProcFeeAssignmentsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ProcurationFeeAssignmentsGetAllDefaultProcFeeAssignmentsResponses, ProcurationFeeAssignmentsGetAllDefaultProcFeeAssignmentsErrors, ThrowOnError>({
        url: '/procuration-fee-assignments/default',
        ...options
    });
};

export const procurationFeeAssignmentsGetFirmProcFeeAssignments = <ThrowOnError extends boolean = true>(options: Options<ProcurationFeeAssignmentsGetFirmProcFeeAssignmentsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ProcurationFeeAssignmentsGetFirmProcFeeAssignmentsResponses, ProcurationFeeAssignmentsGetFirmProcFeeAssignmentsErrors, ThrowOnError>({
        url: '/procuration-fee-assignments/{firmId}',
        ...options
    });
};

export const procurationFeeAssignmentsCreateChangeRequest = <ThrowOnError extends boolean = true>(options: Options<ProcurationFeeAssignmentsCreateChangeRequestData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ProcurationFeeAssignmentsCreateChangeRequestResponses, ProcurationFeeAssignmentsCreateChangeRequestErrors, ThrowOnError>({
        url: '/procuration-fee-assignments',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const procurationFeeAssignmentsValidateDelete = <ThrowOnError extends boolean = true>(options: Options<ProcurationFeeAssignmentsValidateDeleteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ProcurationFeeAssignmentsValidateDeleteResponses, ProcurationFeeAssignmentsValidateDeleteErrors, ThrowOnError>({
        url: '/procuration-fee-assignments/validate-delete',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const procurationFeeAssignmentsCreateDeleteCr = <ThrowOnError extends boolean = true>(options: Options<ProcurationFeeAssignmentsCreateDeleteCrData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ProcurationFeeAssignmentsCreateDeleteCrResponses, ProcurationFeeAssignmentsCreateDeleteCrErrors, ThrowOnError>({
        url: '/procuration-fee-assignments/delete-cr',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const procurationFeeAssignmentsCreateReorderChangeRequest = <ThrowOnError extends boolean = true>(options: Options<ProcurationFeeAssignmentsCreateReorderChangeRequestData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ProcurationFeeAssignmentsCreateReorderChangeRequestResponses, ProcurationFeeAssignmentsCreateReorderChangeRequestErrors, ThrowOnError>({
        url: '/procuration-fee-assignments/reorder',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const procurationFeeAssignmentsGetData = <ThrowOnError extends boolean = true>(options: Options<ProcurationFeeAssignmentsGetDataData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ProcurationFeeAssignmentsGetDataResponses, ProcurationFeeAssignmentsGetDataErrors, ThrowOnError>({
        url: '/procuration-fee-assignments/{actionId}/data',
        ...options
    });
};

export const procurationFeeAssignmentsAddOrUpdateData = <ThrowOnError extends boolean = true>(options: Options<ProcurationFeeAssignmentsAddOrUpdateDataData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ProcurationFeeAssignmentsAddOrUpdateDataResponses, ProcurationFeeAssignmentsAddOrUpdateDataErrors, ThrowOnError>({
        url: '/procuration-fee-assignments/{actionId}/data',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const procurationFeeAssignmentsDeleteData = <ThrowOnError extends boolean = true>(options: Options<ProcurationFeeAssignmentsDeleteDataData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<ProcurationFeeAssignmentsDeleteDataResponses, ProcurationFeeAssignmentsDeleteDataErrors, ThrowOnError>({
        url: '/procuration-fee-assignments/{actionId}/data/{rowNumbers}',
        ...options
    });
};

export const procurationFeeAssignmentsGetResult = <ThrowOnError extends boolean = true>(options: Options<ProcurationFeeAssignmentsGetResultData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ProcurationFeeAssignmentsGetResultResponses, ProcurationFeeAssignmentsGetResultErrors, ThrowOnError>({
        url: '/procuration-fee-assignments/{actionId}/result',
        ...options
    });
};

export const procurationFeeRulesGetAllProcurationFeeRules = <ThrowOnError extends boolean = true>(options?: Options<ProcurationFeeRulesGetAllProcurationFeeRulesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ProcurationFeeRulesGetAllProcurationFeeRulesResponses, ProcurationFeeRulesGetAllProcurationFeeRulesErrors, ThrowOnError>({
        url: '/procuration-fee-rules',
        ...options
    });
};

export const procurationFeeRulesCreateChangeRequest = <ThrowOnError extends boolean = true>(options: Options<ProcurationFeeRulesCreateChangeRequestData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ProcurationFeeRulesCreateChangeRequestResponses, ProcurationFeeRulesCreateChangeRequestErrors, ThrowOnError>({
        url: '/procuration-fee-rules',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const procurationFeeRulesCheckUsage = <ThrowOnError extends boolean = true>(options: Options<ProcurationFeeRulesCheckUsageData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ProcurationFeeRulesCheckUsageResponses, ProcurationFeeRulesCheckUsageErrors, ThrowOnError>({
        url: '/procuration-fee-rules/usage',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const procurationFeeRulesValidateDelete = <ThrowOnError extends boolean = true>(options: Options<ProcurationFeeRulesValidateDeleteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ProcurationFeeRulesValidateDeleteResponses, ProcurationFeeRulesValidateDeleteErrors, ThrowOnError>({
        url: '/procuration-fee-rules/validate-delete',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const procurationFeeRulesCreateDeleteCr = <ThrowOnError extends boolean = true>(options: Options<ProcurationFeeRulesCreateDeleteCrData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ProcurationFeeRulesCreateDeleteCrResponses, ProcurationFeeRulesCreateDeleteCrErrors, ThrowOnError>({
        url: '/procuration-fee-rules/delete-cr',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const procurationFeeRulesGetData = <ThrowOnError extends boolean = true>(options: Options<ProcurationFeeRulesGetDataData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ProcurationFeeRulesGetDataResponses, ProcurationFeeRulesGetDataErrors, ThrowOnError>({
        url: '/procuration-fee-rules/{actionId}/data',
        ...options
    });
};

export const procurationFeeRulesAddOrUpdateData = <ThrowOnError extends boolean = true>(options: Options<ProcurationFeeRulesAddOrUpdateDataData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ProcurationFeeRulesAddOrUpdateDataResponses, ProcurationFeeRulesAddOrUpdateDataErrors, ThrowOnError>({
        url: '/procuration-fee-rules/{actionId}/data',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const procurationFeeRulesDeleteData = <ThrowOnError extends boolean = true>(options: Options<ProcurationFeeRulesDeleteDataData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<ProcurationFeeRulesDeleteDataResponses, ProcurationFeeRulesDeleteDataErrors, ThrowOnError>({
        url: '/procuration-fee-rules/{actionId}/data/{rowNumbers}',
        ...options
    });
};

export const procurationFeeRulesGetResult = <ThrowOnError extends boolean = true>(options: Options<ProcurationFeeRulesGetResultData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ProcurationFeeRulesGetResultResponses, ProcurationFeeRulesGetResultErrors, ThrowOnError>({
        url: '/procuration-fee-rules/{actionId}/result',
        ...options
    });
};

export const procurationFeesGetAllProcurationFees = <ThrowOnError extends boolean = true>(options?: Options<ProcurationFeesGetAllProcurationFeesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ProcurationFeesGetAllProcurationFeesResponses, ProcurationFeesGetAllProcurationFeesErrors, ThrowOnError>({
        url: '/procuration-fees',
        ...options
    });
};

export const procurationFeesCreateChangeRequest = <ThrowOnError extends boolean = true>(options: Options<ProcurationFeesCreateChangeRequestData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ProcurationFeesCreateChangeRequestResponses, ProcurationFeesCreateChangeRequestErrors, ThrowOnError>({
        url: '/procuration-fees',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const procurationFeesCheckUsage = <ThrowOnError extends boolean = true>(options: Options<ProcurationFeesCheckUsageData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ProcurationFeesCheckUsageResponses, ProcurationFeesCheckUsageErrors, ThrowOnError>({
        url: '/procuration-fees/usage',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const procurationFeesValidateDelete = <ThrowOnError extends boolean = true>(options: Options<ProcurationFeesValidateDeleteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ProcurationFeesValidateDeleteResponses, ProcurationFeesValidateDeleteErrors, ThrowOnError>({
        url: '/procuration-fees/validate-delete',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const procurationFeesCreateDeleteCr = <ThrowOnError extends boolean = true>(options: Options<ProcurationFeesCreateDeleteCrData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ProcurationFeesCreateDeleteCrResponses, ProcurationFeesCreateDeleteCrErrors, ThrowOnError>({
        url: '/procuration-fees/delete-cr',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const procurationFeesGetData = <ThrowOnError extends boolean = true>(options: Options<ProcurationFeesGetDataData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ProcurationFeesGetDataResponses, ProcurationFeesGetDataErrors, ThrowOnError>({
        url: '/procuration-fees/{actionId}/data',
        ...options
    });
};

export const procurationFeesAddOrUpdateData = <ThrowOnError extends boolean = true>(options: Options<ProcurationFeesAddOrUpdateDataData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ProcurationFeesAddOrUpdateDataResponses, ProcurationFeesAddOrUpdateDataErrors, ThrowOnError>({
        url: '/procuration-fees/{actionId}/data',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const procurationFeesDeleteData = <ThrowOnError extends boolean = true>(options: Options<ProcurationFeesDeleteDataData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<ProcurationFeesDeleteDataResponses, ProcurationFeesDeleteDataErrors, ThrowOnError>({
        url: '/procuration-fees/{actionId}/data/{rowNumbers}',
        ...options
    });
};

export const procurationFeesGetResult = <ThrowOnError extends boolean = true>(options: Options<ProcurationFeesGetResultData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ProcurationFeesGetResultResponses, ProcurationFeesGetResultErrors, ThrowOnError>({
        url: '/procuration-fees/{actionId}/result',
        ...options
    });
};

export const productChangesGetData = <ThrowOnError extends boolean = true>(options: Options<ProductChangesGetDataData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ProductChangesGetDataResponses, ProductChangesGetDataErrors, ThrowOnError>({
        url: '/products/changes/{actionId}/data',
        ...options
    });
};

export const productChangesAddOrUpdateData = <ThrowOnError extends boolean = true>(options: Options<ProductChangesAddOrUpdateDataData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ProductChangesAddOrUpdateDataResponses, ProductChangesAddOrUpdateDataErrors, ThrowOnError>({
        url: '/products/changes/{actionId}/data',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const productChangesDeleteData = <ThrowOnError extends boolean = true>(options: Options<ProductChangesDeleteDataData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<ProductChangesDeleteDataResponses, ProductChangesDeleteDataErrors, ThrowOnError>({
        url: '/products/changes/{actionId}/data/{rowNumbers}',
        ...options
    });
};

export const productChangesSubmitForReview = <ThrowOnError extends boolean = true>(options: Options<ProductChangesSubmitForReviewData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ProductChangesSubmitForReviewResponses, ProductChangesSubmitForReviewErrors, ThrowOnError>({
        url: '/products/changes/{actionId}/submit-for-review',
        ...options
    });
};

export const productChangesGetResult = <ThrowOnError extends boolean = true>(options: Options<ProductChangesGetResultData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ProductChangesGetResultResponses, ProductChangesGetResultErrors, ThrowOnError>({
        url: '/products/changes/{actionId}/result',
        ...options
    });
};

export const productChangesApplyColumnDelta = <ThrowOnError extends boolean = true>(options: Options<ProductChangesApplyColumnDeltaData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ProductChangesApplyColumnDeltaResponses, ProductChangesApplyColumnDeltaErrors, ThrowOnError>({
        url: '/products/changes/{actionId}/apply-column-delta',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const productExclusivitySetsGetAllSets = <ThrowOnError extends boolean = true>(options?: Options<ProductExclusivitySetsGetAllSetsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ProductExclusivitySetsGetAllSetsResponses, ProductExclusivitySetsGetAllSetsErrors, ThrowOnError>({
        url: '/products/exclusivitySets',
        ...options
    });
};

export const productExclusivitySetsCreateChangeRequest = <ThrowOnError extends boolean = true>(options: Options<ProductExclusivitySetsCreateChangeRequestData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ProductExclusivitySetsCreateChangeRequestResponses, ProductExclusivitySetsCreateChangeRequestErrors, ThrowOnError>({
        url: '/products/exclusivitySets',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const productExclusivitySetsCheckUsage = <ThrowOnError extends boolean = true>(options: Options<ProductExclusivitySetsCheckUsageData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ProductExclusivitySetsCheckUsageResponses, ProductExclusivitySetsCheckUsageErrors, ThrowOnError>({
        url: '/products/exclusivitySets/usage',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const productExclusivitySetsValidateDelete = <ThrowOnError extends boolean = true>(options: Options<ProductExclusivitySetsValidateDeleteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ProductExclusivitySetsValidateDeleteResponses, ProductExclusivitySetsValidateDeleteErrors, ThrowOnError>({
        url: '/products/exclusivitySets/validate-delete',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const productExclusivitySetsCreateDeleteCr = <ThrowOnError extends boolean = true>(options: Options<ProductExclusivitySetsCreateDeleteCrData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ProductExclusivitySetsCreateDeleteCrResponses, ProductExclusivitySetsCreateDeleteCrErrors, ThrowOnError>({
        url: '/products/exclusivitySets/delete-cr',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const productExclusivitySetsGetData = <ThrowOnError extends boolean = true>(options: Options<ProductExclusivitySetsGetDataData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ProductExclusivitySetsGetDataResponses, ProductExclusivitySetsGetDataErrors, ThrowOnError>({
        url: '/products/exclusivitySets/{actionId}/data',
        ...options
    });
};

export const productExclusivitySetsAddOrUpdateData = <ThrowOnError extends boolean = true>(options: Options<ProductExclusivitySetsAddOrUpdateDataData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ProductExclusivitySetsAddOrUpdateDataResponses, ProductExclusivitySetsAddOrUpdateDataErrors, ThrowOnError>({
        url: '/products/exclusivitySets/{actionId}/data',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const productExclusivitySetsDeleteData = <ThrowOnError extends boolean = true>(options: Options<ProductExclusivitySetsDeleteDataData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<ProductExclusivitySetsDeleteDataResponses, ProductExclusivitySetsDeleteDataErrors, ThrowOnError>({
        url: '/products/exclusivitySets/{actionId}/data/{rowNumbers}',
        ...options
    });
};

export const productExclusivitySetsGetResult = <ThrowOnError extends boolean = true>(options: Options<ProductExclusivitySetsGetResultData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ProductExclusivitySetsGetResultResponses, ProductExclusivitySetsGetResultErrors, ThrowOnError>({
        url: '/products/exclusivitySets/{actionId}/result',
        ...options
    });
};

export const productsGetAllProducts = <ThrowOnError extends boolean = true>(options?: Options<ProductsGetAllProductsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ProductsGetAllProductsResponses, ProductsGetAllProductsErrors, ThrowOnError>({
        url: '/products',
        ...options
    });
};

export const productsGetProductCodes = <ThrowOnError extends boolean = true>(options?: Options<ProductsGetProductCodesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ProductsGetProductCodesResponses, ProductsGetProductCodesErrors, ThrowOnError>({
        url: '/products/product-codes',
        ...options
    });
};

export const staffGetAll = <ThrowOnError extends boolean = true>(options?: Options<StaffGetAllData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<StaffGetAllResponses, unknown, ThrowOnError>({
        url: '/staff',
        ...options
    });
};

export const staffGetById = <ThrowOnError extends boolean = true>(options: Options<StaffGetByIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<StaffGetByIdResponses, StaffGetByIdErrors, ThrowOnError>({
        url: '/staff/{id}',
        ...options
    });
};

export const createTableView = <ThrowOnError extends boolean = true>(options: Options<CreateTableViewData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateTableViewResponses, CreateTableViewErrors, ThrowOnError>({
        url: '/tableViews',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const getTableViewsForADataType = <ThrowOnError extends boolean = true>(options: Options<GetTableViewsForADataTypeData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetTableViewsForADataTypeResponses, unknown, ThrowOnError>({
        url: '/tableViews/{entityType}',
        ...options
    });
};

export const deleteTableView = <ThrowOnError extends boolean = true>(options: Options<DeleteTableViewData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteTableViewResponses, DeleteTableViewErrors, ThrowOnError>({
        url: '/tableViews/{viewId}',
        ...options
    });
};

export const updateTableViews = <ThrowOnError extends boolean = true>(options: Options<UpdateTableViewsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpdateTableViewsResponses, UpdateTableViewsErrors, ThrowOnError>({
        url: '/tableViews/{viewId}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const translationsGetTranslations = <ThrowOnError extends boolean = true>(options?: Options<TranslationsGetTranslationsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<TranslationsGetTranslationsResponses, TranslationsGetTranslationsErrors, ThrowOnError>({
        url: '/translations',
        ...options
    });
};

export const translationsGetTranslation = <ThrowOnError extends boolean = true>(options: Options<TranslationsGetTranslationData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<TranslationsGetTranslationResponses, TranslationsGetTranslationErrors, ThrowOnError>({
        url: '/translations/{term}',
        ...options
    });
};

export const usersGetCurrentUserPermissions = <ThrowOnError extends boolean = true>(options?: Options<UsersGetCurrentUserPermissionsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<UsersGetCurrentUserPermissionsResponses, unknown, ThrowOnError>({
        url: '/users/me/permissions',
        ...options
    });
};